import React from 'react';
import '../../styles/forwarding.css'; // Import Forwarding specific CSS
import '../../styles/Fonts.css'; // Import Fonts specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

const ForwardingServices = () => {
  return (
    <>
      {/* Forwarding Services Section */}
      <section id="forwarding-services" className="about-preview-section">
        <div className="container">
          <div className="about-content-wrapper">
            <div className="about-text-content">
              <div className="section-badge">WHAT WE PROVIDE</div>
              <h2 className="section-title">Our Forwarding Services</h2>
              <p className="section-description">
                Our comprehensive forwarding services streamline your domestic and international 
                shipments with precision and expertise. We ensure your goods move efficiently 
                across borders while maintaining cost-effectiveness.
              </p>
              <p className="section-description">
                From small parcels to large cargo, our solutions are tailored to your specific 
                requirements. We handle all aspects of customs, compliance, and safety protocols, 
                delivering a seamless experience from origin to destination.
              </p>
              
              <div className="hero-actions mt-4">
                <a href="/contactUs" className="btn-primary-hero">Get Started</a>
              </div>
            </div>
            <div className="about-image-content">
              <div className="about-stats">
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-plane"></i>
                  </div>
                  <span className="stat-number">Air Freight</span>
                  <div className="stat-label">Fast air cargo services</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-warehouse"></i>
                  </div>
                  <span className="stat-number">Warehousing</span>
                  <div className="stat-label">Storage and distribution</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-truck"></i>
                  </div>
                  <span className="stat-number">Land Transport</span>
                  <div className="stat-label">Domestic forwarding</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-file-alt"></i>
                  </div>
                  <span className="stat-number">Documentation</span>
                  <div className="stat-label">Complete paperwork handling</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForwardingServices;
